import type { PermissionName, PermissionStatusMap } from '../types';

export const deriveMissingPermissions = (
  required: readonly PermissionName[],
  statuses: PermissionStatusMap
): PermissionName[] =>
  required.filter((permission) => statuses[permission] !== 'granted');
